export const ModalActions = {
  OPEN_MODAL: 'pharmacy-modal/open-modal',
  CLOSE_MODAL: 'pharmacy-modal/close-modal'
};
